import ConfigurationItem from './ConfigurationItem'

export default ConfigurationItem
